import { render, staticRenderFns } from "./search-crumbs.vue?vue&type=template&id=354f6613&scoped=true"
import script from "./search-crumbs.vue?vue&type=script&lang=js"
export * from "./search-crumbs.vue?vue&type=script&lang=js"
import style0 from "./search-crumbs.vue?vue&type=style&index=0&id=354f6613&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "354f6613",
  null
  
)

export default component.exports